// src/pages/painel/ExcluirRefeicaoModal.js
import React from "react";
import "./excluirRefeicaoModal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTriangleExclamation,
  faDrumstickBite,
  faFireFlameCurved,
  faClock,
} from "@fortawesome/free-solid-svg-icons";

const ExcluirRefeicaoModal = ({ refeicao, onClose, onConfirm }) => {
  if (!refeicao) return null;

  const handleFundoClick = (e) => {
    if (e.target.classList.contains("excluir-refeicao-fundo")) {
      if (onClose) onClose();
    }
  };

  const handleConfirmar = () => {
    if (onConfirm) onConfirm(refeicao);
  };

  const tipoRefeicaoTexto = (() => {
    const id = Number(refeicao.refeicao_tipo_id);
    if (id === 1) return "Café da manhã";
    if (id === 2) return "Almoço";
    if (id === 3) return "Jantar";
    if (id === 4) return "Lanche";
    return "Refeição";
  })();

  const dataHoraFormatada = (() => {
    if (!refeicao.data_hora_refeicao) return "-";
    // "2025-12-06 18:12:44" -> Date
    const str = String(refeicao.data_hora_refeicao).replace(" ", "T");
    const d = new Date(str);
    if (Number.isNaN(d.getTime())) return refeicao.data_hora_refeicao;

    const dia = String(d.getDate()).padStart(2, "0");
    const mes = String(d.getMonth() + 1).padStart(2, "0");
    const ano = d.getFullYear();
    const hora = String(d.getHours()).padStart(2, "0");
    const min = String(d.getMinutes()).padStart(2, "0");

    return `${dia}/${mes}/${ano} às ${hora}:${min}`;
  })();

  const descricaoOriginal = (refeicao.descricao_original || "").trim();

  return (
    <div className="excluir-refeicao-fundo" onClick={handleFundoClick}>
      <div className="excluir-refeicao-container">
        <div className="excluir-refeicao-icone-wrapper">
          <div className="excluir-refeicao-icone-circulo">
            <FontAwesomeIcon
              icon={faTriangleExclamation}
              className="excluir-refeicao-icone-alerta"
            />
          </div>
        </div>

        <h2 className="excluir-refeicao-titulo">Excluir refeição</h2>

        <p className="excluir-refeicao-texto">
          Tem certeza que deseja excluir esta refeição? Esta ação não pode ser
          desfeita.
        </p>

        {/* Card "Você registrou:" replicando o estilo do modal de detalhes */}
        {descricaoOriginal && (
          <div className="excluir-refeicao-registrado-card">
            <div className="excluir-refeicao-registrado-titulo">
              Você registrou:
            </div>
            <div className="excluir-refeicao-registrado-texto">
              “{descricaoOriginal}”
            </div>
          </div>
        )}

        <div className="excluir-refeicao-detalhes-card">
          <div className="excluir-refeicao-linha">
            <span className="excluir-refeicao-label">
              <span className="excluir-refeicao-icone-inline">
                <FontAwesomeIcon icon={faDrumstickBite} />
              </span>
              Tipo
            </span>
            <span className="excluir-refeicao-valor">{tipoRefeicaoTexto}</span>
          </div>

          <div className="excluir-refeicao-linha">
            <span className="excluir-refeicao-label">
              <span className="excluir-refeicao-icone-inline">
                <FontAwesomeIcon icon={faClock} />
              </span>
              Data e hora
            </span>
            <span className="excluir-refeicao-valor">
              {dataHoraFormatada}
            </span>
          </div>

          <div className="excluir-refeicao-linha excluir-refeicao-linha-kcal">
            <span className="excluir-refeicao-label">
              <span className="excluir-refeicao-icone-inline">
                <FontAwesomeIcon icon={faFireFlameCurved} />
              </span>
              Calorias
            </span>
            <span className="excluir-refeicao-kcal">
              {refeicao.calorias_total} kcal
            </span>
          </div>
        </div>

        <div className="excluir-refeicao-botoes">
          <button
            type="button"
            className="btn-excluir-cancelar"
            onClick={onClose}
          >
            Cancelar
          </button>

          <button
            type="button"
            className="btn-excluir-confirmar"
            onClick={handleConfirmar}
          >
            Excluir refeição
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExcluirRefeicaoModal;
